import React from 'react';
export const Nav00DataSource = {
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children:
      'https://www.wshoto.com/resource/website_new/images/index-nav-logo.png?v=1',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '/wi_website_index.php',
          children: [
            {
              children: (
                <>
                  <p>首页</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/wi_website_product.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>产品中心</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/wi_website_case.php',
          children: [
            {
              children: (
                <>
                  <p>案例中心</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/wi_website_product-manual.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>帮助中心</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k315jln721q',
        className: 'header0-item',
        children: {
          href: '/wi_website_joinin.php',
          children: [
            {
              children: (
                <>
                  <p>合作伙伴</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k315kgkx2m',
        className: 'header0-item',
        children: {
          href: '/wi_website_news.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>企微学院</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k315kqbkra',
        className: 'header0-item',
        children: {
          href: '/wi_website_aboutus.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>了解微盛</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k481t05n1i',
        className: 'header0-item',
        children: {
          href: '/wi_user_login.php',
          children: [
            {
              children: (
                <>
                  <p>登录</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};
export const Banner30DataSource = {
  wrapper: { className: 'banner3 k31bfwc7k9-editor_css' },
  textWrapper: {
    className: 'banner3-text-wrapper k3166u8abp-editor_css',
    children: [
      {
        name: 'nameEn',
        className: 'banner3-name-en k31bmzd8ay-editor_css',
        children: (
          <>
            <p>
              <br />
            </p>
          </>
        ),
      },
      {
        name: 'slogan',
        className: 'banner3-slogan k3161gnsy9-editor_css',
        children: '微盛SCRM小程序全面深度集成企业微信',
        texty: true,
      },
      {
        name: 'name',
        className: 'banner3-name k47wsih1pkf-editor_css',
        children: (
          <>
            <p>
              企业微信+小程序 打造企业数字化转型闭环<br />
            </p>
          </>
        ),
      },
      {
        name: 'button',
        className: 'banner3-button k32rfy3lf56-editor_css',
        children: (
          <>
            <p>免费试用</p>
          </>
        ),
        href: 'https://www.wshoto.com/wi_user_login.php',
        target: '_blank',
        type: 'primary',
      },
      {
        name: 'button~k3168n14y2',
        className:
          'ant-btn-primary ant-btn banner3-button ant-btn-default k3168ouqrl7-editor_css',
        children: (
          <>
            <p>立即咨询</p>
          </>
        ),
        type: 'default',
        href: 'http://wpa.qq.com/msgrd?v=3&amp;uin=&amp;site=qq&amp;menu=yes',
        target: '_blank',
      },
    ],
  },
};
export const Content00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper k484wba3aa-editor_css',
  },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>什么是企业微信私有化</p>
          </>
        ),
        className: 'k316npqafw-editor_css',
      },
      {
        name: 'title~k5ksrc9ywj',
        className: 'k5ksrgmm6jq-editor_css',
        children: (
          <>
            <p>私有化部署，提供更多选择面向政府及大型企业&nbsp;</p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5ksz0gsypi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/2869cd7bff2893e307144b6821721c02.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k485lka3ij-editor_css',
              children: (
                <>
                  <p>部署灵活</p>
                </>
              ),
            },
            {
              name: 'content',
              children: (
                <>
                  <p>
                    可部署在用户自己的服务器上，支持各种复杂的网络环境，与已有的IT基础设施有效融合。
                  </p>
                </>
              ),
              className: 'k5kt0pknbke-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5kt1s5as8',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5ksz0gsypi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/9dcd90a3f9466baf0fd33b3d88c29ca0.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k485lka3ij-editor_css',
              children: (
                <>
                  <p>安全可控</p>
                </>
              ),
            },
            {
              name: 'content',
              children: (
                <>
                  <p>
                    支持端到端数据加密，提供灵活的安全管理策略，并获得国家各种安全资质认证。
                  </p>
                </>
              ),
              className: 'k5kt0pknbke-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5kt1sri4q8',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5ksz0gsypi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/90de8e05c59e58886db698b915a73ab1.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k485lka3ij-editor_css',
              children: (
                <>
                  <p>与SaaS一致的功能体验</p>
                </>
              ),
            },
            {
              name: 'content',
              children: (
                <>
                  <p>
                    基础的沟通、组织管理、API接口等能力与企业微信SAAS版本保持一致。
                  </p>
                </>
              ),
              className: 'k5kt0pknbke-editor_css',
            },
          ],
        },
      },
    ],
  },
};
export const Feature41DataSource = {
  wrapper: { className: 'home-page-wrapper content6-wrapper' },
  OverPack: { className: 'home-page content6' },
  textWrapper: {
    className: 'content6-text k67houd8m5c-editor_css',
    xs: 24,
    md: 10,
  },
  titleWrapper: {
    className: 'title-wrapper k5kt7fy2q5m-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>提供私有化部署运维开发服务，支持定制化开发</p>
          </>
        ),
        className: 'title-h1 k5kt4h4uew-editor_css',
      },
      {
        name: 'content~k5kt7ojay7g',
        className: 'k5kt8bgvnlk-editor_css',
        children: (
          <>
            <p>政府客户和大企业客户</p>
          </>
        ),
      },
      {
        name: 'content~k5ktbhu6g06',
        className: 'k5ktbm1ylkh-editor_css',
        children: (
          <>
            <p>注重安全的客户</p>
          </>
        ),
      },
      {
        name: 'content~k5ktbs9q7eq',
        className: 'k5ktcayf64-editor_css',
        children: (
          <>
            <p>私有部署，本地维护</p>
          </>
        ),
      },
      {
        name: 'content~k5ktbt46ocr',
        className: 'k5ktcdzjseb-editor_css',
        children: (
          <>
            <p>有一定的建设使用成本</p>
          </>
        ),
      },
      {
        name: 'content~k5ktbvy61j',
        className: 'k5ktcfnhj0p-editor_css',
        children: (
          <>
            <p>数据在本地，企业自主管控</p>
          </>
        ),
      },
      {
        name: 'content~k5ktbz6uefj',
        className: 'k5ktcket7am-editor_css',
        children: (
          <>
            <p>部分功能灵活自定义</p>
          </>
        ),
      },
    ],
  },
  img: {
    children:
      'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/b015c3406802c05c32c9232741d4fc8a.png',
    className: 'content6-img',
    xs: 24,
    md: 14,
  },
  block: {
    children: [
      {
        name: 'block0',
        img: {
          children:
            'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/1ceeb7d8ff032fd1806bb9f55c35c6a7.png',
          className: 'content6-icon k5ktfhzb5v-editor_css',
        },
        title: {
          className: 'content6-title k5ktg1mw19k-editor_css',
          children: (
            <>
              <p>企业微信私有化</p>
            </>
          ),
        },
        content: {
          className: 'content6-content k5ktefqvlsd-editor_css',
          children: (
            <>
              <p>
                <br />
              </p>
            </>
          ),
        },
        className: 'k5ktejd9uz-editor_css',
      },
      {
        name: 'block~k5ktm279d6',
        img: {
          children:
            'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/327c41b31610a82c1e5c95629a91b126.png',
          className: 'content6-icon k5ktfhzb5v-editor_css',
        },
        title: {
          className: 'content6-title k5ktg1mw19k-editor_css',
          children: (
            <>
              <p>政务微信私有化</p>
            </>
          ),
        },
        content: {
          className: 'content6-content k5ktefqvlsd-editor_css',
          children: (
            <>
              <p>
                <br />
              </p>
            </>
          ),
        },
        className: 'k5ktejd9uz-editor_css',
      },
    ],
    className: 'k5kthdkyy7-editor_css',
  },
};
export const Banner53DataSource = {
  wrapper: { className: 'home-page-wrapper banner5 k4i8dhr3fpf-editor_css' },
  page: { className: 'home-page banner5-page k4i8fp8v5c-editor_css' },
  childWrapper: {
    className: 'banner5-title-wrapper k4i8e71lmu-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>
              微盛企业微信私有化业务团队优势<br />
            </p>
          </>
        ),
        className: 'banner5-title k4i8eou8bs-editor_css',
      },
      {
        name: 'title~k4id2i53f3l',
        className: 'k4id2jzsws-editor_css',
        children: (
          <>
            <p>
              工程师通过私有化培训和考试获得证书<br />
            </p>
          </>
        ),
      },
      {
        name: 'title~k4i8iv3tr88',
        className: 'k4i8j4y42ga-editor_css',
        children: (
          <>
            <p>百人技术团队支持</p>
          </>
        ),
      },
      {
        name: 'title~k4i8iwhr77',
        className: 'k4i8jp96nr-editor_css',
        children: (
          <>
            <p>签约私有化部署运维服务商与经销商</p>
          </>
        ),
      },
      {
        name: 'title~k4i8o09r4uc',
        className: 'k4i8o8q06nu-editor_css',
        children: (
          <>
            <p>企业微信应用开发支持</p>
          </>
        ),
      },
      {
        name: 'title~k4i8o2odif7',
        className: 'k4i8oq7onat-editor_css',
        children: (
          <>
            <p>部署实施案例经验丰富&nbsp;</p>
          </>
        ),
      },
    ],
  },
  image: {
    className: 'banner5-image k4i8fo678ia-editor_css',
    children:
      'https://www.wshoto.com/resource/website_new/images/new/peixun.png',
  },
};
export const Content120DataSource = {
  wrapper: { className: 'home-page-wrapper content12-wrapper' },
  page: { className: 'home-page content12' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>使用案例&nbsp;</p>
          </>
        ),
        className: 'title-h1',
      },
    ],
  },
  block: {
    className: 'img-wrapper',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children:
              'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/90e5dfedcacaaf2b0db3f842df2a05c7.png',
          },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children:
              'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/2b96bcf1cad4ac83da8f375e1b43f7f7.png',
          },
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children:
              'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/1d1712aef7f9f6c1b943e200cdda84aa.png',
          },
        },
      },
      {
        name: 'block3',
        className: 'block',
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children:
              'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/889c762b010d5ddf233bb53b8dce4139.png',
          },
        },
      },
      {
        name: 'block4',
        className: 'block',
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children:
              'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87-%E4%BC%81%E5%BE%AE%E5%AE%9A%E5%88%B6/40870cd62dad54d0bb8820bf296b145c.png',
          },
        },
      },
    ],
  },
};
export const Content110DataSource = {
  OverPack: {
    className: 'home-page-wrapper content11-wrapper k317ziqoic-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>Hi，现在注册，享好礼！</p>
          </>
        ),
        className: 'title-h1 k318183k996-editor_css',
      },
    ],
  },
  button: {
    className: '',
    children: {
      a: {
        className: 'button',
        href: 'https://www.wshoto.com/wi_user_login.php',
        children: (
          <>
            <p>即刻开启私域</p>
          </>
        ),
        target: '_blank',
        type: 'default',
      },
    },
  },
};
export const Contact00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content10-wrapper k32su1h3tc-editor_css',
  },
  Content: {
    className: 'icon-wrapper',
    children: {
      icon: {
        className: 'icon',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/zIUVomgdcKEKcnnQdOzw.svg',
        name: '主要图标',
      },
      iconShadow: {
        className: 'icon-shadow',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/WIePwurYppfVvDNASZRN.svg',
        name: '图标影阴',
      },
      url: {
        children:
          'https://router.map.qq.com/short?l=c68c329a0b1d624f863ff19911b71739',
        name: '跳转地址',
      },
      title: { children: '公司地址', name: '弹框标题' },
      content: {
        children: '微盛小程序 江苏微盛网络科技有限公司',
        name: '弹框内容',
      },
    },
  },
};
export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page k317qox00p-editor_css',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block k319huz377-editor_css',
        title: {
          className: 'logo',
          children:
            'https://www.wshoto.com/resource/website_new/images/index-nav-logo.png',
        },
        childWrapper: {
          className: 'slogan k31a2k968um-editor_css',
          children: [
            {
              name: 'content0',
              children: (
                <>
                  <p>基于企业微信的行业SCRM解决方案</p>
                </>
              ),
              className: 'k31a2veocw6-editor_css',
            },
            {
              name: 'image~k319ceqayh',
              className: 'k319cpthlg-editor_css',
              children: '',
            },
            {
              name: 'image~k319cgwc11n',
              className: 'k319ciwpn89-editor_css',
              children: '',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block k49b5xaw2ct-editor_css',
        title: {
          children: (
            <>
              <p>云业务</p>
            </>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: 'https://www.wshoto.com/wi_website_qcloudso.php',
              children: (
                <>
                  <p>联合解决方案</p>
                </>
              ),
              className: 'k317s8b5dk8-editor_css',
              target: '_blank',
            },
            {
              name: 'link1',
              href: 'https://www.wshoto.com/wi_website_shopping.php',
              children: (
                <>
                  <p>优惠购买</p>
                </>
              ),
              className: 'k317scp5att-editor_css',
              target: '_blank',
            },
            {
              name: 'link~k32seujj06n',
              href:
                'https://qcloud.wshoto.com/wshotocloud/activity.wshotocloud.com/free_test/index.html',
              children: (
                <>
                  <p>免费体验</p>
                </>
              ),
              className: 'k317scp5att-editor_css',
              target: '_blank',
            },
          ],
          className: 'k317s8vk249-editor_css',
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <>
              <p>招商加盟</p>
            </>
          ),
        },
        childWrapper: {
          children: [
            {
              href: 'https://www.wshoto.com/wi_website_joinin.php',
              name: 'link0',
              children: (
                <>
                  <p>产品优势</p>
                </>
              ),
              className: 'k49blu3q21f-editor_css',
            },
            {
              href: 'https://www.wshoto.com/wi_website_joinin.php',
              name: 'link1',
              children: (
                <>
                  <p>扶持体系</p>
                </>
              ),
              className: 'k49bmjmeku-editor_css',
            },
            {
              href: '#',
              name: 'link~k32seoc7wm',
              children: (
                <>
                  <p>
                    <br />
                  </p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <>
              <p>了解微盛</p>
            </>
          ),
        },
        childWrapper: {
          children: [
            {
              href: 'https://www.wshoto.com/wi_website_aboutus.php',
              name: 'link0',
              children: (
                <>
                  <p>关于我们</p>
                </>
              ),
              className: 'k319fv578f-editor_css',
            },
            {
              href: 'https://www.wshoto.com/wi_website_advantage.php',
              name: 'link1',
              children: (
                <>
                  <p>我们的优势</p>
                </>
              ),
              className: 'k49bnhbvx8-editor_css',
            },
            {
              href: 'https://www.wshoto.com/wi_website_news.php',
              name: 'link~k32sfv93meu',
              children: (
                <>
                  <p>新闻中心</p>
                </>
              ),
              className: 'k49bnjbtui9-editor_css',
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright k47vbijlci9-editor_css',
    children: (
      <>
        <p>
          Copyright ©江苏微盛网络科技有限公司&nbsp;<a
            href="http://www.beian.miit.gov.cn/state/outPortal/loginPortal.action"
            target="_blank"
            rel="noopener noreferrer"
          >
            苏ICP备15043910-2号
          </a>
        </p>
      </>
    ),
  },
};
